import React from 'react'
import { createUseStyles } from 'react-jss'
import FormInputContainer from '@components/FormInputContainer'
import DataUsageLabel from './DataUsageLabel'
import { typography } from '@dentalux/ui-library-core'
import clsx from 'clsx'
import { Theme, useTheme } from '@mui/material/styles'

const makeUseStyles = (theme: Theme) => (props: Props) => {
  const useStyles = createUseStyles({
    root: {
      marginTop: props.defaultSpacing ? 16 : 0,
    },
    label: {
      position: 'relative',
      top: -4,
      ...typography['Lato Caption'],
      color: theme.palette.grey['600'],
      '& a': {
        textDecoration: 'underline',
        color: theme.palette.primary.main,
        fontWeight: 700,
      },
    },
    errorLabel: {
      marginLeft: 16,
    },
    formInputWrapperRoot: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0,
      width: '100%',
      padding: props.defaultSpacing ? [8, 0] : 0,
    },
  })

  return useStyles
}

interface Props {
  className?: string
  defaultSpacing?: boolean
}

const Legal = ({ className, ...props }: Props) => {
  const theme = useTheme()
  const classes = makeUseStyles(theme)(props)()

  return (
    <div className={clsx(className, classes.root)}>
      <div className={classes.formInputWrapperRoot}>
        <FormInputContainer asColumn>
          <DataUsageLabel className={classes.label} />
        </FormInputContainer>
      </div>
    </div>
  )
}

export default Legal
